// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3BC4R","error":"Textarea_error__1jIl_","readonly":"Textarea_readonly__3htY6","disabled":"Textarea_disabled__2O9ZR"};